import { updateObject } from '../../utils/utility';

const initialState = {
    list: [],
    totalElements: 0,
    pageNumber: 0,
    totalPages: 0,
    listRefreshed: false,
    apiFetchError: false,
    priceUploadTaskComplete: false,
    priceUploadTaskInProgress: false,
    priceUploadTaskError: false,
    priceUploadErrorDesc: "",
    priceUploadTaskErrorCode: "",
    priceUploadTemplateDownloadError: false,
    priceListApprovalResponse: null
};

const setPriceUploadList = (state = initialState, action) => {
        const { bulkUploadList, priceUploadList, totalElements, pageNumber, totalPages } = action.payload;
        return updateObject(state, { 
            list: bulkUploadList || priceUploadList,
            totalElements: totalElements,
            pageNumber: pageNumber,
            totalPages: totalPages,
            listRefreshed: true,
            apiFetchError: false
        }
    );
};


const setListRefreshed = (state = initialState, action) => {
    return updateObject(state, {
        listRefreshed : action.data
    });
};

const setAPIFetchError = (state = initialState, action) => {
    return updateObject(state, {
        apiFetchError : action.data,
        listRefreshed : action.data
    });
};

const setPriceUploadComplete = (state = initialState, action) => {
    return updateObject(state, {
        priceUploadTaskComplete : true,
        priceUploadTaskInProgress: false,
        priceUploadTaskError: false,
        priceUploadTaskErrorCode: ""
    });
};

const resetPriceUploadTask = (state = initialState, action) => {
    return updateObject(state, {
        priceUploadTaskComplete : false,
        priceUploadTaskInProgress: false,
        priceUploadTaskError: false,
        priceUploadTemplateDownloadError: false,
        priceUploadTaskErrorCode: "",
        priceUploadErrorDesc: ""
    });
};

const setPriceUploadError = (state = initialState, action) => {
    return updateObject(state, {
        priceUploadTaskComplete : true,
        priceUploadTaskInProgress: false,
        priceUploadTaskError: true,
        priceUploadErrorDesc: action.errorDesc
    });
};

const setPriceUploadInProgress = (state = initialState, action) => {
    return updateObject(state, {
        priceUploadTaskInProgress: true
    });
};

const setpriceUploadTaskErrorCode = (state = initialState, action) => {
    return updateObject(state, {
        priceUploadTaskErrorCode: action.data
    });
};

const setPriceUploadTemplateDownloadError = (state = initialState, action) => {
    return updateObject(state, {
        priceUploadTemplateDownloadError: action.data
    });
};

const setPriceListApprovalResponse = (state = initialState, action) => {
    return updateObject(state, {
        priceListApprovalResponse: action.payload
    });
};

const reducer = (state = initialState, action) => {
    if (action.type === "SET_CUSTOMER_PRICE_UPLOAD_LIST") {
        return setPriceUploadList(state, action);
    }
    if (action.type === "SET_CUSTOMER_LIST_REFRESHED") {
        return setListRefreshed(state, action);
    }
    if (action.type === "SET_CUSTOMER_API_FETCH_ERROR") {
        return setAPIFetchError(state, action);
    }
    if (action.type === "SET_CUSTOMER_PRICE_UPLOAD_IN_PROGRESS") {
        return setPriceUploadInProgress(state, action);
    }
    if (action.type === "SET_CUSTOMER_PRICE_UPLOAD_COMPLETE") {
        return setPriceUploadComplete(state, action);
    }
    if (action.type === "SET_CUSTOMER_PRICE_UPLOAD_ERROR") {
        return setPriceUploadError(state, action);
    }
    if (action.type === "RESET_CUSTOMER_PRICE_UPLOAD_TASK") {
        return resetPriceUploadTask(state, action);
    }
    if (action.type === "SET_CUSTOMER_PRICE_UPLOAD_TEMPLATE_DOWNLOAD_ERROR") {
        return setPriceUploadTemplateDownloadError(state, action);
    }
    if (action.type === "SET_CUSTOMER_PRICE_UPLOAD_TASK_ERROR_CODE") {
        return setpriceUploadTaskErrorCode(state, action);
    }
    if (action.type === "SET_CUSTOMER_PRICE_LIST_APPROVAL_RESPONSE") {
        return setPriceListApprovalResponse(state, action);
    }
    return state;
}

export default reducer;
